import { useState, useContext } from "react"
import { Button, Form, Modal } from "react-bootstrap"
import axios from 'axios'
import { UserContext } from '../../hooks/UserContext';
import { ContentContext } from '../../hooks/ContentContext';
import SelectCourseCategory from './SelectCourseCategory'
import SelectCourseType from './SelectCourseType'
import SelectCourseStatus from './SelectCourseStatus'
import { FileUpload } from 'primereact/fileupload';

export default function NewCourse({ onCreated }) {
  const [show, setShow] = useState(false);
  const { user } = useContext(UserContext);
  const { selectedCourse, handleCourseChange } = useContext(ContentContext);

  // Form data
  const [name, setName] = useState();
  const [description, setDescription] = useState();
  const [categories, setCategories] = useState([]);
  const [type, setType] = useState();
  const [status, setStatus] = useState();
  const [uploadUrl, setUploadUrl] = useState();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const createCourse = async () => {
    let url = "/api/courses";
    let data;

    try {
      const response = await axios.post(url, {
        name: name,
        description: description,
        cover_image: uploadUrl,
        categories: categories.map(cat => cat.value),
        type_id: parseInt(type.value),
        status_id: parseInt(status.value)
      }, {
        headers: { 'Authorization': `Bearer ${user.token}`, 'X-EDITOR': 'nanoms' },
      });
      data = response.data;
    } catch (error) {
      console.error(error);
    }

    setName()
    setDescription()
    setCategories()
    setType()
    setStatus()
    setUploadUrl()
    return data
  }

  const handleSubmit = async e => {
    e.preventDefault();
    setShow(false);
    console.log("New course is going to be created here")
    const result = await createCourse();
    handleCourseChange({ id: result.id, name: result.name });
    if (onCreated) onCreated();
    console.log(`Course created with result: ${result} `)
  }

  const handleCategoryChange = (currentCategory) => {
    setCategories(currentCategory);
    console.log(`We changed category and selected category is ${currentCategory}`)
    console.log(currentCategory)
  };

  const handleTypeChange = (currentType) => {
    setType(currentType);
    console.log(`We changed type and selected category is ${currentType.name}`)
    console.log(currentType)
  };

  const handleStatusChange = (currentStatus) => {
    setStatus(currentStatus);
    console.log(`We changed type and selected status is ${currentStatus.name}`)
    console.log(currentStatus)
  };

  const onBeforeSend = (e) => {
    e.xhr.setRequestHeader('Authorization', `Bearer ${user.token}`);
    e.formData.append('folder', 'course_cover_images');
  }

  const onUpload = (event) => {
    const url = JSON.parse(event.xhr.response).location
    setUploadUrl(url);
  }

  return (
    <>
      <button className="ne-btn ne-btn-ghost" onClick={handleShow}>
        <i className="pi pi-plus" /> New course
      </button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add New Course</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group controlId="formCourseName">
            <Form.Label>Name: </Form.Label>
            <Form.Control type="text" onChange={e => setName(e.target.value)} value={name} placeholder="" />
          </Form.Group>
          <Form.Group controlId="formCourseDescription">
            <Form.Label>Description: </Form.Label>
            <Form.Control type="text" onChange={e => setDescription(e.target.value)} value={description} placeholder="" />
          </Form.Group>
          <Form.Group controlId="formCourseCategory">
            <Form.Label>Category: </Form.Label>
            {/* <Form.Control type="text" onChange={e => handleCategoryChange(e.target.value)} value={categories} placeholder="" /> */}
            <SelectCourseCategory
              onCategorySelect={handleCategoryChange}
            />
          </Form.Group>
          <Form.Group controlId="formCourseType">
            <Form.Label>Type: </Form.Label>
            <SelectCourseType
              onTypeSelect={handleTypeChange}
            />
          </Form.Group>
          <Form.Group controlId="formCourseStatus">
            <Form.Label>Status: </Form.Label>
            <SelectCourseStatus
              onStatusSelect={handleStatusChange}
            />
          </Form.Group>
          <Form.Group controlId="formUploadCoverImage">
            <Form.Label>Cover Image: </Form.Label>
            <Form.Control type="text" value={uploadUrl} placeholder="" readOnly />
            <FileUpload
              mode="basic"
              name="file"
              url="/api/upload"
              accept="image/*"
              maxFileSize={5000000}
              onBeforeSend={onBeforeSend}
              onUpload={onUpload}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            Add
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}